module.exports = __webpack_public_path__ + "img/loginLog.ba5cea6e.jpg";